<template>
  <div class="section-category">
    <div class="section-pay mx-auto">
      <h2 class="ttl-pay text-center" v-translate>PAY CASH</h2>
      <div class="form-row">
        <div class="col-12">
          <div class="form-group row line pb-2">
            <div class="ttl col-7" v-translate>Total amount</div>
            <div class="col-5 txt-r pay-ttl">{{ totalAmount | currency }}</div>
          </div>
          <div class="form-group row line pb-2">
            <label class="col-7 ttl mb-0" v-translate>Cash</label>
            <div class="col-5 txt-r pay-ttl">{{ payCash | currency }}</div>
          </div>
          <div class="form-group row">
            <div class="ttl col-7 ttl"><strong v-translate>Change</strong></div>
            <div class="col-5 txt-r pay-ttl"><strong>{{ totalChange | currency }}</strong></div>
          </div>
        </div>
        <div class="button-footer">
          <button type="button" class="btn btn-primary" @click="closeBill" v-translate>Close</button>
          <router-link :to="{name: 'order'}" class="btn btn-default" v-translate>Cancel</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { SET_MESSAGE_MODAL } from '@/store/mutation-types';

export default {
  name: 'PayCash',
  computed: {
    payCash: {
      get() { return this.getMap('payCash', true) },
      set(value) { this.$store.state.bill.payCash = value; },
    },
    ...mapState({
      bill: state => state.bill.bill,
    }),
    ...mapGetters(['totalAmount', 'totalChange']),
  },
  methods: {
    async closeBill() {
      if (this.totalChange >= 0) {
        this
          .$store
          .dispatch(
            'closeBill',
            {
              id: this.bill.id,
              payDetails: {payCash: this.payCash}
            }
          );
      } else {
        this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('Amount not paid in full'));
      }
    },
  },
  mounted() {
    if(!this.bill.id) this.$router.replace({ name: 'order' });
    if (this.payCash === null || this.payCash.length === 0 || this.payCash == 0) {
      const currency = this.$store.state.auth.currency;
      if (currency && currency.decimalType) {
        this.payCash = parseFloat(this.totalAmount).toFixed(2);
      } else {
        this.payCash = Math.ceil(parseFloat(this.totalAmount));
      }
    }
  },
};
</script>
